export default __webpack_public_path__ + "36657f4ba653abbe2fe6ebc3f08d0afd.png";